<template>
    <div>
        <nav 
            class="navbar is-transparent" 
            role="navigation" 
            aria-label="main navigation"            
        >
            <div class="navbar-brand">
                <a class="navbar-item">
                    <img src="@/assets/images/general_nylogo_website.svg" width="200" alt="General Hotell - logo">
                </a>

                <!-- <a role="button" class="navbar-burger burger" data-target="navMenu" aria-label="menu" aria-expanded="false">
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                </a> -->
            </div>

            <div class="navbar-menu" id="navMenu" role="navigation" aria-label="main navigation">
                <div class="navbar-end">
                    <a class="navbar-item">
                        <router-link 
                            to="/" 
                            class="has-text-weight-bold is-size-5"
                        >
                            Hjem
                        </router-link>
                    </a>
                    <a class="navbar-item">
                        <router-link
                            to="pizzeria-del-generale"
                            class="has-text-weight-bold is-size-5"
                        >
                            Pizzeria del Generale
                        </router-link>
                    </a>
<!--     
                    <a class="navbar-item">
                        <router-link 
                            to="/konferanse" 
                            class="has-text-weight-bold is-size-5"
                        >
                        Konferanse
                        </router-link>
                    </a>   

                    <div class="navbar-item has-dropdown is-hoverable">
                        <a class="navbar-link has-text-weight-bold is-size-5">
                            Mat & Drikke
                        </a>
                        <div class="navbar-dropdown">
                            <a class="navbar-item has-text-weight-bold">
                                <router-link
                                    to="/pizzeria-del-generale"
                                >
                                Pizzeria del Generale
                                </router-link>
                            </a>
                            <a class="navbar-item has-text-weight-bold menyvalg" href="https://www.reservasjoner.no/book/bordbestilling" target="_self" alt="Lenke til bordbestilling">
                                - Bordbestilling
                            </a>    
                            <a class="navbar-item  has-text-weight-bold menyvalg" href="https://www.reservasjoner.no/book/take-away" target="_self" alt="Lenke til takeaway-bestilling">
                                - Takeaway
                            </a>    
                            <a class="navbar-item has-text-weight-bold">
                                <router-link
                                    to="/selskap"
                                >                            
                                Selskap
                                </router-link>
                            </a>                         
                            <a class="navbar-item has-text-weight-bold">
                                <router-link
                                    to="/catering"
                                >                            
                                Catering
                                </router-link>
                            </a> 
                            <a class="navbar-item has-text-weight-bold">
                                <router-link
                                    to="/blogg"
                                >                            
                                Blogg
                                </router-link>
                            </a>                                                        
                        </div>     
                    </div>            
                
                    <div class="navbar-item has-dropdown is-hoverable menyjustering">
                        <a class="navbar-link has-text-weight-bold is-size-5">
                            Opplevelser
                        </a>
                        <div class="navbar-dropdown">
                            <a class="navbar-item has-text-weight-bold">
                                <router-link
                                    to="/opplevelser/spill"
                                >
                                Spill
                                </router-link>
                            </a>
                            <a class="navbar-item has-text-weight-bold">
                                <router-link
                                    to="/opplevelser/aktiviteter"
                                >                            
                                Aktiviteter
                                </router-link>
                            </a>                                       
                        </div>     
                    </div> 

                    <div class="navbar-item has-dropdown is-hoverable menyjustering">
                        <a class="navbar-link has-text-weight-bold is-size-5">
                            Om oss
                        </a>
                        <div class="navbar-dropdown">
                            <a class="navbar-item has-text-weight-bold">
                                <router-link
                                    to="/om-oss/bedriften"
                                >
                                Kort om bedriften
                                </router-link>
                            </a>
                            <a class="navbar-item has-text-weight-bold">
                                <router-link
                                    to="/om-oss/jobb"
                                >                            
                                Jobb hos oss
                                </router-link>
                            </a>      
                            <a class="navbar-item has-text-weight-bold">
                                <router-link
                                    to="/om-oss/yrke"
                                >                            
                                Yrkesreisende
                                </router-link>
                            </a>       
                            <a class="navbar-item has-text-weight-bold">
                                <router-link
                                    to="/om-oss/kontakt"
                                >                            
                                Kontakt oss
                                </router-link>
                            </a> 
                            <a class="navbar-item has-text-weight-bold">
                                <router-link
                                    to="/om-oss/veien-hit"
                                >                            
                                Veien hit
                                </router-link>
                            </a>
                            <a class="navbar-item has-text-weight-bold">
                                <router-link
                                    to="/om-oss/personvern"
                                >                            
                                Personvern
                                </router-link>
                            </a>                                  
                        </div>     
                    </div>  
                    -->                          
                </div>		
            </div>
        </nav>
    </div>
</template>
 
<script>
import '../styles/_variables.scss'

export default {
    data: function() {
        return {
            test: null
		}
	}
}

// Burger
document.addEventListener('DOMContentLoaded', () => {

  // Get all "navbar-burger" elements
  const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

  // Check if there are any navbar burgers
  if ($navbarBurgers.length > 0) {

    // Add a click event on each of them
    $navbarBurgers.forEach( el => {
      el.addEventListener('click', () => {

        // Get the target from the "data-target" attribute
        const target = el.dataset.target;
        const $target = document.getElementById(target);

        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        el.classList.toggle('is-active');
        $target.classList.toggle('is-active');

      });
    });
  }

});

</script>


<style scoped>
a {
    color: #ffffff;
}
a :hover {
    color: #dabc42
}

a.menyvalg {
    color: #000000;
}

.navbar-dropdown > .navbar-item > .menyvalg > a:hover {
    color: #dabc42;
}

.navbar-dropdown > .navbar-item > a {
    color: #000000;
}

.navbar-dropdown > .navbar-item > a:hover {
    color: #dabc42;
}

.navbar-item img {
    max-height: 4rem; /* Var 3.5 */
}

.navbar {
    background-color: transparent !Important;
}



@media screen and (max-width:1023px) {
    .navbar-menu {
        background-color: #cccc !Important;
    }
}

@media screen and (min-width:1280px) {
    .menyjustering {
        margin-left:-40px;
    }
}
</style>






